
const customerClubStatus = document.querySelector('#customer-club');
const marketingStatus = document.querySelector('#marketing');

const updateCustomerClub = async (button, selector) => {
  const checkbox = document.querySelector(`#${selector}`);

  if(!marketingStatus.checked && checkbox.checked) {
    alert(window.theme.strings.customer_club_unsubscribe_alert);
    checkbox.checked = false
    return
  }

  checkbox.disabled = true;

  button.disabled = true;

  await fetch(
    `https://konges-sloejd-middleman.vercel.app/api/update-customer-club/${theme.customer_club.store}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customer: window.customer.id,
        email: window.customer.email,
        status: checkbox.checked,
      }),
    }
  )
    .then((response) => response)
    .then(() => {
      button.disabled = false;
      checkbox.disabled = false;
      customerClubStatus.checked = checkbox.checked
    });
};

const updateMarketingPermission = async (button, selector) => {
  const checkbox = document.querySelector(`#${selector}`);

  if (customerClubStatus.checked && !checkbox.checked) {
    alert(window.theme.strings.marketing_unsubscribe_alert);
    checkbox.checked = true
    return
  }
  checkbox.disabled = true;

  button.disabled = true;

  await fetch(
    `https://konges-sloejd-middleman.vercel.app/api/update-marketing-permission/${theme.customer_club.store}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customer: window.customer.id,
        email: window.customer.email,
        status: checkbox.checked,
      }),
    }
  )
    .then((response) => response)
    .then(() => {
      button.disabled = false;
      checkbox.disabled = false;
      marketingStatus.checked = checkbox.checked;
    });
};


document.querySelector('.marketing-accept-button')?.addEventListener('click', function(){
  updateMarketingPermission(this, 'marketing-accept');
});

document.querySelector('.club-accept-button')?.addEventListener('click', function(){
  updateCustomerClub(this, 'customer-club-accept');
});